import type { ReactElement } from 'react'

import { ArmchairIcon, BuildingIcon, ConstructionIcon, MoneyRisingIcon } from 'components/new-icons'

export type HomeRenovationUseCase = {
  id: string
  icon: ReactElement
  title: string
  description: string
}

export const homeRenovationUseCases: HomeRenovationUseCase[] = [
  {
    id: 'old-apartment',
    icon: <BuildingIcon color="var(--colors-pink-text-contrast)" />,
    title: 'Comprou um apartamento antigo?',
    description: 'Modernize os ambientes e deixe o imóvel com a sua cara.'
  },
  {
    id: 'home-improvements',
    icon: <ConstructionIcon color="var(--colors-pink-text-contrast)" />,
    title: 'Sua casa precisa de melhorias?',
    description: 'Resolva problemas estruturais sem adiar decisões importantes.'
  },
  {
    id: 'comfort',
    icon: <ArmchairIcon color="var(--colors-pink-text-contrast)" />,
    title: 'Quer investir em conforto?',
    description: 'Renove espaços para atender às necessidades da sua família.'
  },
  {
    id: 'future',
    icon: <MoneyRisingIcon color="var(--colors-pink-text-contrast)" />,
    title: 'Está pensando no futuro?',
    description: 'Uma reforma bem planejada pode contribuir para a valorização do imóvel.'
  }
]
